// extracted by mini-css-extract-plugin
module.exports = {"input":"input-mask_input__1PGIK","label":"input-mask_label__3wJhY","alert":"input-mask_alert__FZY8W"};